import OrderView from "./OrderView.vue"

const base = "/order"

export default [
    {
        path: base + "/:uuid",
        name: "orderdetailform",
        props: true,
        component: OrderView
    }
]
